import styled from 'styled-components';
export const Footer = styled.div`
  z-index: 100;
  background-color: #f1edee;
  border-top: 1px solid #6b6b6b;
  position: fixed;
  bottom: 0;
  right: calc(50% - 100vw / 2);
  height: 7rem;
  width: calc(100% - 6rem);
  padding: 1rem;
  display: flex;
  justify-content: right;
  align-items: flex-end;
  img {
    height: 4rem;
  }
  @media (max-width: 601px) {
    width: 100%;
    height: 4rem;
    img {
      height: 2rem;
    }
  }
`;
